module.exports = __webpack_public_path__ + "media/photo/comminutions_meet-137ad274.png";